import { render, staticRenderFns } from "./newsIndex.vue?vue&type=template&id=6ea1ba56&scoped=true"
import script from "./newsIndex.vue?vue&type=script&lang=js"
export * from "./newsIndex.vue?vue&type=script&lang=js"
import style0 from "./newsIndex.vue?vue&type=style&index=0&id=6ea1ba56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea1ba56",
  null
  
)

export default component.exports